import '../styles/index.scss';
import 'accordion-js/dist/accordion.min.css';
import 'lazysizes';

async function loadModules() {
  const { default: header } = await import('./modules/header');
  const { default: scrollReveal } = await import('./modules/scrollReveal');
  const { default: newsletterForm } = await import('./modules/newsletterForm');
  const { default: contact } = await import('./modules/contact');
  const { default: dropdown } = await import('./modules/dropdown');
  const { default: birds } = await import('./modules/birds');

  header();
  scrollReveal();
  newsletterForm();
  contact();
  dropdown();
  birds();

  const homePage = document.querySelector('.home');
  const instinctPage = document.querySelector('.instinct');
  const investorPage = document.querySelector('.investor');
  const impactPage = document.querySelector('.impact');

  if (homePage) {
    const { default: heroScroll } = await import('./modules/heroScroll');
    const { default: rotateText } = await import('./modules/rotateText');
    const { default: marquee } = await import('./modules/marquee');

    heroScroll();
    rotateText();
    marquee();
  }

  if (instinctPage) {
    const { default: svgAnimate } = await import('./modules/svgAnimate');
    svgAnimate();
  }

  if (impactPage) {
    const { default: scrambleWords } = await import('./modules/scrambleWords');
    scrambleWords();
  }

  if (investorPage) {
    const { default: loginForm } = await import('./modules/loginForm');
    loginForm();
  }
}

document.addEventListener('DOMContentLoaded', loadModules);
